import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=06b5cb02&scoped=true"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=06b5cb02&prod&lang=stylus&scoped=true"
import style1 from "./AddGoods.vue?vue&type=style&index=1&id=06b5cb02&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b5cb02",
  null
  
)

export default component.exports